<div class="container">
  <div class="booking-body">
    <ng-container *ngIf="isMobile">
      <ng-container *ngTemplateOutlet="busesSectors"></ng-container>
    </ng-container>
    <ng-container class="body-buses-booking">
      <form *ngIf="user" [formGroup]="bookingFlightsForm" class="booking-form-info">
        <section class="pax-section-cont">
          <div class="title">
            <app-ds-typography
              [tag]="'h3'"
              [size]="fontSize.XS"
              [color]="fontColor.Primary"
              [fontFamily]="fontFamily.SemiBold"
              [text]="'PASSENGERS' | transloco">
            </app-ds-typography>
          </div>
          <div class="description">
            <app-ds-typography
              [tag]="'p'"
              [size]="fontSize.XXS"
              [color]="fontColor.Secondary"
              [fontFamily]="fontFamily.Regular"
              [text]="'BOOKING_MODULE.PAX.GENERAL_DESCRIPTION' | transloco">
            </app-ds-typography>
          </div>
          <ng-container *ngFor="let passengerUI of passengerListUI$ | async | filterPassengerListUI: adults; index as i">
            <app-pax-section
              [validator]="airValidation"
              [countries]="countries$ | async | countriesVm"
              [travelerType]="passengerUI.TravelerType"
              [listUILength]="passengerListUI$ | async | lengthPassengerListUI: adults"
              [travelerInfoType]="passengerUI.TravelerInfoType"
              [paxTravelers]="travelers$ | async | travelerListVm : passengerUI.TravelerType : passengerUII(i) : startDate | async"
              [ordinalKey]="passengerUI.OrdinalKey"
              [defaultData]="passengerUI.defaultData"
              [form]="bookingFlightsForm"
              [user]="user"
              [isSubmittedSuccess]="isSubmittedSuccess"
              [isSubmitted]="isSubmitted"
              [travelerNumber]="i"
              [isMobile]="isMobile"
              [travelerBookingProvider]="travelerBookingProvider"
              [businessRules]="businessRules$ | async"
              (selectPax)="selectTravelerPax($event, i)"
              (removePax)="deleteTravelerPax($event, i)"
              (createPax)="createTravelerPax($event, bookingFlightsForm, { id: i, TravelerInfoType: passengerUI.TravelerInfoType }, startDate)"
              (updatePax)="updateTravelerPax($event, bookingFlightsForm, { id: i, TravelerInfoType: passengerUI.TravelerInfoType })"
              (amplitudeEvent)="trackBookingAmplitudeEvent($event, travelerBookingProvider)">
            </app-pax-section>
          </ng-container>
        </section>
        <ng-container *ngIf="paxSectionReady">
          <section *ngIf="activeBillingModule" #sectionBillingRef>
            <ng-container *ngTemplateOutlet="billingSectionTemplate"></ng-container>
          </section>
          <section class="contact-info-cont" #sectionContactDetails>
            <app-contact-section
              [form]="bookingFlightsForm"
              [isSubmitted]="isSubmitted"
              [isMobile]="isMobile"
              [user]="user">
            </app-contact-section>
          </section>
          <section>
            <app-policies-detail
              [policiesType]="policiesType"
              [isMobile]="isMobile"
              [airValidation]="airValidation"
              [isBookingView]="true">
            </app-policies-detail>
          </section>
          <app-fare-info [textFare]="airValidation?.TripOption?.TextFare"></app-fare-info>
          <section class="content-banner">
            <ng-container *ngTemplateOutlet="chubbBookingBanner"></ng-container>
          </section>
          <section class="terms-cont" #sectionPaymentDetail *ngIf="isMobile">
            <app-payment-detail
              [passengerArrangement]="passengerArrangementsState$ | async"
              [price]="airValidation?.TripOption?.Price"
              [isBuses]="true"
              [isMobile]="isMobile">
            </app-payment-detail>
          </section>
          <section class="terms-cont" #sectionTermsRef>
            <app-terms-and-conditions
              [form]="bookingFlightsForm"
              [isSubmitted]="isSubmitted">
            </app-terms-and-conditions>
          </section>
        </ng-container>
        <section *ngIf="applyConversion$  | async">
          <app-exchange-rate-info 
            [conversionRate]="conversionRate$ | async">
          </app-exchange-rate-info>
        </section>
        <section *ngIf="activeCallSupportModule">
          <app-support-info></app-support-info>
        </section>
        <app-btn-go-to-pay
          [isMobile]="isMobile"
          [disabled]="(bookingReady$ | async) === false"
          [isLoadingBooking]="isLoadingBookingDelay"
          [applyConversion]="applyConversion$ | async"
          [conversionRate]="conversionRate$ | async"
          [finalPrice]="airValidation?.TripOption?.Price?.Total"
          [currencyCode]="airValidation?.TripOption?.Price?.CurrencyCode"
          [productReference]="airValidation?.TripOption?.ProductReference"
          (goToPay)="submitBookingOptions($event)">
        </app-btn-go-to-pay>
      </form>
    </ng-container>
    <ng-container *ngIf="!isMobile">
      <div class="booking-payment-detail">
        <div class="payment-detail-cont">
          <ng-container *ngTemplateOutlet="paymentDetail"></ng-container>
          <ng-container *ngIf="hasairValidation">
            <ng-container *ngTemplateOutlet="itineraryDetail"></ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #busesSectors>
  <app-travel-segment-detail
    [validationVm]="airValidation | airValidationVm"
    [summaryProvider]="busesSummaryProvider"
    (showFlightDetail)="showBusesDetail($event)">
  </app-travel-segment-detail>
</ng-template>

<ng-template #paymentDetail>
  <app-payment-detail
    [passengerArrangement]="passengerArrangementsState$ | async"
    [price]="airValidation?.TripOption?.Price"
    [conversionRate]="conversionRate$ | async"
    [isMobile]="isMobile"
    [isBuses]="true"
    [productReference]="airValidation?.TripOption?.ProductReference">
  </app-payment-detail>
</ng-template>

<ng-template #itineraryDetail>
  <app-itinerary-detail
    [isMobile]="isMobile"
    [flightClass]="flightClass$ | async"
    [airValidationSector]="airValidation?.TripOption?.Sectors"
    [travelType]="travelerBookingProvider">
  </app-itinerary-detail>
</ng-template>

<ng-template #billingSectionTemplate>
  <ng-container *ngIf="billingModuleIsOptional; else billingModuleTemplate">
    <ng-container *ngTemplateOutlet="optinalBillingModuletemplate"></ng-container>
  </ng-container>

  <ng-template #optinalBillingModuletemplate>
    <app-optional-billing-box
      [showBillingModule]="showBillingModule"
      (setShowBillingModule)="setShowBillingModule($event)">
    </app-optional-billing-box>
    <ng-container *ngTemplateOutlet="billingModuleTemplate; context: { hiddenHeader: true }"></ng-container>
  </ng-template>
  
  <ng-template #billingModuleTemplate let-hiddenHeader='hiddenHeader'>
    <ng-container *ngIf="showBillingModuleData">
      <app-billing
        [isSubmitted]="isSubmitted"
        [bookingForm]="bookingFlightsForm"
        [countries]="countries$ | async | countriesVm"
        [cities]="cities$ | async"
        [user]="user"
        [isMobile]="isMobile"
        [showHeaderInfo]="!hiddenHeader">
      </app-billing>
    </ng-container>
  </ng-template>
</ng-template>

<ng-template #chubbBookingBanner let-isPayment="isPayment">
  <app-chubb-booking-banner
    [bookingType]="travelerBookingProvider"
    [days]="airValidation.TripOption.LengthOfStay || 1"
    [travelers]="travelerInfoList?.length"
    [isInternationalTrip]="isAnInternationalTrip$ | async"
    [isPayment]="!!isPayment"
    [assistanceInfo]="assistanceSearchInfo$ | async"
    [isActivateFreeChubbAssistance]="isActivateFreeChubbAssistance$ | async"
    [isPrimeUser]="isPrimeUser$ | async"
    (showPaymentOfferDetails)="setShowAssistanceDetails(true)">>
  </app-chubb-booking-banner>
</ng-template>

<ng-container *ngIf="isActivePaidAssistance$ | async">
  <app-travel-assistance
    [bookingType]="travelerBookingProvider"
    [isMobile]="isMobile"
    [showAssistanceInfo]="showAssistanceInfo$ | async"
    [assistanceInfo]="assistanceSearchInfo$ | async"
    [totalPrice]="airValidation?.TripOption?.Price?.Total"
    [isLoading]="isLoadingBookingDelay"
    [showDetailInfo]="showAssistanceDetails$ | async"
    [applyConversion]="applyConversion$ | async"
    [conversionRate]="conversionRate$ | async"
    (hiddenAssistanceDetails)="setShowAssistanceDetails(false)"
    (payButtonEvent)="submitBookingOptionsByAssistance($event)"
    (exitEvent)="closeAssistanceInfo()"
    (amplitudeTrigger)="trackBookingAmplitudeEvent($event, travelerBookingProvider)">
    <ng-container assistanceBanner>
      <ng-container *ngTemplateOutlet="chubbBookingBanner; context: { isPayment: true }"></ng-container>
    </ng-container>
  </app-travel-assistance>
</ng-container>
